const ActiveSchoolPopUp = ({ setShowUnblock }) => {
  return (
    <>
      <div className="p-3 main_card_popup_box">
        <button
          className="main_card_popup_button"
          onClick={() => {
            setShowUnblock(true);
          }}
        >
          Unblock
        </button>
      </div>
    </>
  );
};
export default ActiveSchoolPopUp;
